import React, {Component} from 'react';
import {Row, Col, Progress, Card, CardTitle, CardHeader, CardFooter, ButtonToolbar, CardBody, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, Alert} from 'reactstrap';
import { ajaxWrapperGet,ajaxWrapperGetQuery } from '../../../utils/deviceAPI';

import LoadingIndicator from '../../../utils/LoadingIndicator';
import moment from 'moment'
import DeviceOffline from '../DeviceMessages/DeviceOffline';
import Graph from './Graph';
import Error from '../DeviceMessages/Error';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import {isDeviceOnline} from "../../../utils/isDeviceOnline";
import { Bar, Line } from 'react-chartjs-2';

const brandPrimary = getStyle('--primary');
const brandSuccess = getStyle('--success');
const brandInfo = getStyle('--info');
const brandWarning = getStyle('--warning');
const brandDanger = getStyle('--danger');
// Main Chart






class Historical extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            startDate: moment().subtract(1, 'hours'),
            endDate: moment()
        };
    }
    componentDidMount() {
        this.setData();

    }

    componentWillUnmount(){

    }
    componentWillReceiveProps(nextProps) {
        const dev = this.props.match.params.dev.replace('device_','');
        const newDev = nextProps.match.params.dev.replace('device_','');
        if (dev !== newDev ) {
            this.setData(newDev);
        }
    }

    selectedDate(timePeriod, startDateMoment = null, endDateMoment = null) {
        let startDate = 0;
        let endDate = 0;
        let now = moment();
        switch (timePeriod) {
            case "Custom":
                startDate =  moment(startDateMoment).unix();
                endDate = moment(endDateMoment).unix();
                break;
            case "Day":
                startDate =  now.startOf('day').unix();
                endDate = moment().unix();
                break;
            case "12H":
                startDate =  now.subtract(12, 'hours').unix();
                endDate = moment().unix();
                break;
            case "6H":
                startDate =  now.subtract(6, 'hours').unix();
                endDate = moment().unix();
                break;
            case "3H":
                startDate =  now.subtract(3, 'hours').unix();
                endDate = moment().unix();
                break;
            case "1H":
                startDate =  now.subtract(1, 'hours').unix();
                endDate = moment().unix();
                break;
        }
        this.setData(this.props.match.params.dev.replace('device_',''),startDate,endDate);
    }

    setData(device = this.props.match.params.dev.replace('device_',''),startDate = 0, endDate = 0) {
        startDate = startDate === 0 ? this.state.startDate.unix() : startDate;
        endDate = endDate === 0 ? this.state.endDate.unix() : endDate;
        let query = `&startdate=${startDate}&enddate=${endDate}`;
        ajaxWrapperGetQuery('/api/deviceHistoricalData',device,query).then((data) => {
            console.log(data);
            for (let item = 0; item < data.charts.length; item++) {
                data.charts[item]['chartOptions'].tooltips.custom = CustomTooltips;
                data.charts[item]['chartOptions'].tooltips.callbacks = {
                    labelColor: function(tooltipItem, chart) {
                        return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
                    }
                };
            }
            this.setState({
                data,
                loading: false,
                startDate: startDate,
                endDate: endDate
            });

        });
    }



    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        else if (!isDeviceOnline(this.props.uidata.alarms,this.props.match.params.dev.replace('device_',''))) {
            return (
                <DeviceOffline/>
            )
        }
        console.log('startDate : ' + this.state.startDate);
        console.log('endDate : ' + this.state.endDate);
        return (
            <div className="animated fadeIn">
                {this.state.data.charts.map((chart,index) => {
                    return (
                        <Row key={index}>
                            <Col>
                                <Graph mainChart={chart.chartData}
                                       mainChartOpts={chart.chartOptions}
                                       chartTitle={chart.chartTitle}
                                       startDate={this.state.startDate}
                                       endDate={this.state.endDate}
                                       selectedDate={(timePeriod,startDate,endDate) => this.selectedDate(timePeriod,startDate,endDate)}/>
                            </Col>
                        </Row>

                    )
                })}

            </div>
        )
    }
}

export default Historical;



// WEBPACK FOOTER //
// ./src/views/site/Historical/Historical.js